/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Component imports
import { Col, Form, Input, Row, Typography } from 'antd';

// misc imports
import useTheme from '../../../../utils/hooks/useTheme';
import { FORM_CONFIGURATION_WHATSAPP_INTEGRATION_PATH } from '../../../../constants/deploymentFormPaths';

const BotDeploymentsWhatsAppStrategyGeneralForm = ({ form, hasEditAccess }) => {
  const { t } = useTranslation();
  const { formProps } = useTheme();
  return (
    <Row gutter={formProps.rowGutter} className={formProps.flexDirection}>
      <Col xs={formProps.mainColSpan}>
        <Row>
          <Col flex="auto">
            <Typography.Text>
              {t('Application Settings')}
            </Typography.Text>
            <Typography.Paragraph className="fs-sm" type="secondary">
              {t('Enter the WhatsApp application settings.')}
            </Typography.Paragraph>
          </Col>
        </Row>
      </Col>

      <Col xs={formProps.secondaryColSpan}>
        <Form.Item
          label={t('Access Token')}
          name={[...FORM_CONFIGURATION_WHATSAPP_INTEGRATION_PATH, 'accessToken']}
          rules={[{
            required: true,
            message: t('Please input access token')
          }]}
        >
          {
            hasEditAccess
              ? <Input placeholder={t('Enter Access Token')} />
              : <Typography.Text>{form.getFieldValue([...FORM_CONFIGURATION_WHATSAPP_INTEGRATION_PATH, 'accessToken'])}</Typography.Text>
          }
        </Form.Item>
        <Form.Item
          label={t('Phone Number ID')}
          name={[...FORM_CONFIGURATION_WHATSAPP_INTEGRATION_PATH, 'phoneNumberId']}
          rules={[{
            required: true,
            message: t('Please input phone number ID')
          }]}
        >
          {
            hasEditAccess
              ? <Input placeholder={t('Enter Phone Number ID')} />
              : <Typography.Text>{form.getFieldValue([...FORM_CONFIGURATION_WHATSAPP_INTEGRATION_PATH, 'phoneNumberId'])}</Typography.Text>
          }
        </Form.Item>
      </Col>
    </Row>
  );
};

BotDeploymentsWhatsAppStrategyGeneralForm.propTypes = {
  form: PropTypes.object,
  hasEditAccess: PropTypes.bool
};

export default BotDeploymentsWhatsAppStrategyGeneralForm;
